/* Register the Logerd kiosk service worker.
 * Skipped in development (CRA hot-reload conflicts with SW caching).
 * In production, the SW lives at /service-worker.js and caches the app shell.
 */
export function registerLogerdSW() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  if (process.env.NODE_ENV !== "production") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        // Tell new versions to activate immediately.
        if (reg.waiting) reg.waiting.postMessage({ type: "SKIP_WAITING" });
        reg.addEventListener("updatefound", () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener("statechange", () => {
            if (nw.state === "installed" && navigator.serviceWorker.controller) {
              nw.postMessage({ type: "SKIP_WAITING" });
            }
          });
        });
      })
      .catch(() => {
        /* SW registration failures are non-fatal — app still works online. */
      });
  });
}
